module.exports = __webpack_public_path__ + "img/clock.bd228037.svg";